import {
    UPDATE_ONBOARDING_CONTENT_ERROR,
    UPDATE_ONBOARDING_CONTENT_START,
    UPDATE_ONBOARDING_CONTENT_SUCCESS
} from '../../constants';

import {
    getAllOnBoardingContent,
    updateOnBoardingContent
} from '../../lib/graphql';

import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import history from '../../history';

const updateOnBoardingAction = (values) => {
    return async (dispatch, getState, { client }) => {
        dispatch({ type: UPDATE_ONBOARDING_CONTENT_START });
        dispatch(setLoaderStart('ProviderOnBoardingScreen'));

        try {
            const response = await client.mutate({
                mutation: updateOnBoardingContent,
                variables: values,
                refetchQueries: [{ query: getAllOnBoardingContent }]
            });

            const result = response?.data?.updateOnBoardingContent;

            if (result?.status === '200') {
                dispatch({ type: UPDATE_ONBOARDING_CONTENT_SUCCESS });
                dispatch(setLoaderComplete('ProviderOnBoardingScreen'));

                const messageId = result?.isUpdate
                    ? 'updateOnBoardingContent'
                    : 'addOnBoardingContent';

                showToaster({
                    messageId,
                    toasterType: 'success'
                });
                history.push('/siteadmin/provider-onboarding-screens');
                return result;
            }

            const errorMessage = result?.errorMessage || 'Something went wrong';

            dispatch({ type: UPDATE_ONBOARDING_CONTENT_ERROR });
            dispatch(setLoaderComplete('ProviderOnBoardingScreen'));

            showToaster({
                messageId: 'errorMessage',
                requestContent: errorMessage,
                toasterType: 'error'
            });

        } catch (error) {
            console.error('Update Onboarding Error:', error);

            dispatch({ type: UPDATE_ONBOARDING_CONTENT_ERROR });
            dispatch(setLoaderComplete('ProviderOnBoardingScreen'));

            showToaster({
                messageId: 'catchMessage',
                requestContent: error?.message || error,
                toasterType: 'error'
            });
        }
    };
};

export default updateOnBoardingAction;